import { render } from "./StartMaxPrice.vue?vue&type=template&id=15f16869&scoped=true"
import script from "./StartMaxPrice.vue?vue&type=script&lang=js"
export * from "./StartMaxPrice.vue?vue&type=script&lang=js"

import "./StartMaxPrice.vue?vue&type=style&index=0&id=15f16869&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f16869"]])

export default __exports__